module.exports = __webpack_public_path__ + "static/media/credit-card_visa.f762e3b4.svg";